/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/frame2.glb
*/

import React, { useRef, useEffect, useState } from "react";
import { shaderMaterial, useGLTF, useTexture } from "@react-three/drei";
import { extend, useFrame } from "@react-three/fiber";
import * as THREE from "three";

const FrameMaterial = shaderMaterial(
  {
    uTexture: new THREE.Texture(),
    uFrameSize: new THREE.Vector2(1, 1),
    utextureSize: new THREE.Vector2(0.9, 0.9), // 🛑 Ensure it is initialized
  },
  `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  `
    uniform sampler2D uTexture;
    uniform vec2 utextureSize;
    varying vec2 vUv;

    void main() {
      vec2 centeredUV = vUv - 0.5;
      vec2 scaledUV = centeredUV * utextureSize;
      scaledUV += 0.5;
      scaledUV = clamp(scaledUV, 0.0, 1.0);
      gl_FragColor = texture2D(uTexture, scaledUV);
    }
  `
);

extend({ FrameMaterial });
const frameSizes = [
  {
    size: "4X6",
    depth: 200,
    utextureSize: [0.79, 0.89],
  },
  {
    size: "4X6",
    depth: 300,
    utextureSize: [0.68, 0.79],
  },
  {
    size: "5X7",
    depth: 200,
    utextureSize: [0.85, 0.92],
  },
  {
    size: "5X7",
    depth: 300,
    utextureSize: [0.74, 0.83],
  },
  {
    size: "6X8",
    depth: 200,
    utextureSize: [0.89, 0.95],
  },
  {
    size: "6X8",
    depth: 300,
    utextureSize: [0.79, 0.87],
  },
  {
    size: "8X8",
    depth: 200,
    utextureSize: [0.95, 0.95],
  },
  {
    size: "8X8",
    depth: 300,
    utextureSize: [0.87, 0.87],
  },
  {
    size: "8X10",
    depth: 200,
    utextureSize: [0.95, 0.99],
  },
  {
    size: "8X10",
    depth: 300,
    utextureSize: [0.87, 0.92],
  },
  {
    size: "8X12",
    depth: 200,
    utextureSize: [0.95, 1.02],
  },
  {
    size: "8X12",
    depth: 300,
    utextureSize: [0.87, 0.95],
  },
  {
    size: "10X12",
    depth: 200,
    utextureSize: [0.99, 1.02],
  },
  {
    size: "10X12",
    depth: 300,
    utextureSize: [0.92, 0.96],
  },
  {
    size: "10X14",
    depth: 200,
    utextureSize: [0.99, 1.04],
  },
  {
    size: "10X14",
    depth: 300,
    utextureSize: [0.92, 0.98],
  },
  {
    size: "12X12",
    depth: 200,
    utextureSize: [1.01, 1.01],
  },
  {
    size: "12X12",
    depth: 300,
    utextureSize: [0.95, 0.95],
  },
  {
    size: "12X15",
    depth: 200,
    utextureSize: [1.015, 1.04],
  },
  {
    size: "12X15",
    depth: 300,
    utextureSize: [0.95, 0.99],
  },
  {
    size: "12X16",
    depth: 200,
    utextureSize: [1.027, 1.06],
  },
  {
    size: "12X16",
    depth: 300,
    utextureSize: [0.95, 1],
  },
  {
    size: "12X18",
    depth: 200,
    utextureSize: [1.02, 1.07],
  },
  {
    size: "12X18",
    depth: 300,
    utextureSize: [0.95, 1.02],
  },
  {
    size: "16X20",
    depth: 200,
    utextureSize: [1.06, 1.08],
  },
  {
    size: "16X20",
    depth: 300,
    utextureSize: [1, 1.035],
  },
  {
    size: "20X24",
    depth: 200,
    utextureSize: [1.08, 1.1],
  },
  {
    size: "20X24",
    depth: 300,
    utextureSize: [1.04, 1.06],
  },
  //start from here
  {
    size: "20X30",
    depth: 200,
    utextureSize: [1.08, 1.11],
  },
  {
    size: "20X30",
    depth: 300,
    utextureSize: [1.035, 1.08],
  },
  {
    size: "8X6",
    depth: 200,
    utextureSize: [0.95, 0.89],
  },
  {
    size: "8X6",
    depth: 300,
    utextureSize: [0.87, 0.8],
  },
  {
    size: "10X8",
    depth: 200,
    utextureSize: [0.99, 0.95],
  },
  {
    size: "10X8",
    depth: 300,
    utextureSize: [0.91, 0.86],
  },
  {
    size: "12X8",
    depth: 200,
    utextureSize: [1.02, 0.95],
  },
  {
    size: "12X8",
    depth: 300,
    utextureSize: [0.95, 0.87],
  },
  {
    size: "12X10",
    depth: 200,
    utextureSize: [1.02, 0.99],
  },
  {
    size: "12X10",
    depth: 300,
    utextureSize: [0.95, 0.91],
  },
  {
    size: "14X10",
    depth: 200,
    utextureSize: [1.04, 0.99],
  },
  {
    size: "14X10",
    depth: 300,
    utextureSize: [0.98, 0.92],
  },
  {
    size: "15X12",
    depth: 200,
    utextureSize: [1.05, 1.02],
  },
  {
    size: "15X12",
    depth: 300,
    utextureSize: [0.99, 0.95],
  },
  {
    size: "16X12",
    depth: 200,
    utextureSize: [1.055, 1.02],
  },
  {
    size: "16X12",
    depth: 300,
    utextureSize: [1, 0.95],
  },
  {
    size: "18X12",
    depth: 200,
    utextureSize: [1.07, 1.02],
  },
  {
    size: "18X12",
    depth: 300,
    utextureSize: [1.02, 0.95],
  },
  {
    size: "20X16",
    depth: 200,
    utextureSize: [1.08, 1.06],
  },
  {
    size: "20X16",
    depth: 300,
    utextureSize: [1.03, 1],
  },
  {
    size: "24X20",
    depth: 200,
    utextureSize: [1.099, 1.085],
  },
  {
    size: "24X20",
    depth: 300,
    utextureSize: [1.06, 1.04],
  },

  {
    size: "30X20",
    depth: 200,
    utextureSize: [1.115, 1.08],
  },
  {
    size: "30X20",
    depth: 300,
    utextureSize: [1.08, 1.035],
  },
  {
    size: "24X16",
    depth: 200,
    utextureSize: [1.09, 1.050]
  },
  {
    size: "24X16",
    depth: 300,
    utextureSize: [1.05, 0.9999]
  }
];

function getTextureSize(width, height, depth, scale) {
  const size = frameSizes.find(
    (size) =>
      size.size === `${parseFloat(width) / 200}X${parseFloat(height) / 200}` &&
      size.depth === parseFloat(depth)
  );
  if (size) {
    return size.utextureSize;
  }
  return [1, 1];
}
export function MemorizedFrame({ image, frameSize = "4x8", depth = 200 }) {
  const { nodes } = useGLTF("/3d/frame2.glb");
  const texture = useTexture(image);
  const materialRef = useRef();
  const [aspectX, aspectY] = frameSize.split("x").map(Number);
  const container = useRef();
  const customThickness = 1.5;

  const baseSize = window.innerWidth < 500 ? 1.3 : 2;
  const scaleX = (aspectX / Math.max(aspectX, aspectY)) * baseSize;
  const scaleY = (aspectY / Math.max(aspectX, aspectY)) * baseSize;
  const [isMaterialReady, setMaterialReady] = useState(false);
  const textureSize = getTextureSize(aspectY, aspectX, depth);

  useEffect(() => {
    if (materialRef.current) {
      materialRef.current.uniforms.uTexture.value = texture;
      materialRef.current.uniforms.uFrameSize.value.set(
        aspectX,
        aspectY,
        depth
      );
      materialRef.current.uniforms.utextureSize.value.set(
        textureSize[0],
        textureSize[1]
      );
    }
  }, [isMaterialReady, texture, aspectX, aspectY]);

  useFrame(() => {
    if (container.current) {
      container.current.rotation.y += 0.0015;
    }
  });
  return (
    <group>
      <group
        ref={container}
        dispose={null}
        scale={[scaleX, customThickness, scaleY]}
        rotation={[0, -Math.PI / 2, -Math.PI / 2]}
      >
        <mesh geometry={nodes.Plane.geometry}>
          <frameMaterial
            ref={materialRef}
            key={FrameMaterial.key}
            side={THREE.DoubleSide}
            uFrameSize={new THREE.Vector2(8, 12)}
            utextureSize={new THREE.Vector2(0.95, 1)}
          />
        </mesh>
        <mesh
          geometry={nodes.Plane001.geometry}
          material={nodes.Plane001.material}
        >
          <meshStandardMaterial
            roughness={0.9}
            color="#826a42"
            side={THREE.DoubleSide}
          />
        </mesh>
        <mesh
          geometry={nodes.Object_2001.geometry}
          material={nodes.Object_2001.material}
          position={[-0.915, -0.126, -0.016]}
          rotation={[-1.56, -1.243, 0.004]}
          scale={0.203}
        >
          <meshStandardMaterial metalness={1.0} roughness={0.2} />
        </mesh>
      </group>
    </group>
  );
}
const Frame2 = React.memo(MemorizedFrame);
export { Frame2 };

useGLTF.preload("/3d/frame2.glb");
